<template>
    <div style="align-items: baseline" class="justify-center">
        <div>
            <img :src="headerLogo" alt="Avatar"
                 style="width: 28vw;">
        </div>
        <div class="mt-2 justify-center" style="display: flex; margin-bottom: 13px;">
            <div class="app-name-panel">{{textItem}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["textItem", "headerLogo"]
    };
</script>
